import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { principalPhoneNumber },
} = loanFormModel;

export class PrincipalPhoneNumberValidation implements ValidationSchema {
  public name = principalPhoneNumber.name;
  public label = principalPhoneNumber.label;
  public dependsOn: string[] = [];
  public type = 'string';
  public required = {
    message: principalPhoneNumber.requiredErrorMsg,
    value: principalPhoneNumber.required,
  };
  public nullable = true;
  public min = {
    message: 'Must be 10 digits',
    value: 10,
  };
  public max = {
    message: 'Must be 10 digits',
    value: 10,
  };
  public matches = {
    message:
      'Please enter numbers only (no letters, spaces, or special characters)',
    value: /^[0-9]+$/,
  };
  public typeError = {
    message: 'Must be a number',
    value: true,
  };
}

export default new Validation(new PrincipalPhoneNumberValidation());
